function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Sign out_icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M286.55,419.54h14.86a0.5,0.5,0,1,1,0,1H286.55a0.5,0.5,0,0,1,0-1h0Zm0,0",
  transform: "translate(-285.68 -408.76)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M297.44,415.58a0.5,0.5,0,0,1,.35.14l4,4a0.5,0.5,0,0,1,0,.7l-4,4a0.5,0.5,0,0,1-.7-0.7L300.7,420l-3.61-3.61a0.5,0.5,0,0,1,.35-0.85h0Zm0,0",
  transform: "translate(-285.68 -408.76)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M297.94,409.14a10.89,10.89,0,1,1-10.27,14.53,0.5,0.5,0,0,1,.93-0.33,9.91,9.91,0,1,0,0-6.6,0.5,0.5,0,0,1-.93-0.33,10.91,10.91,0,0,1,10.27-7.26h0Zm0,0",
  transform: "translate(-285.68 -408.76)"
});

var SvgSignOutIcon = function SvgSignOutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 23.53 22.54",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SignOutIcon.284900e4.svg";
export { ForwardRef as ReactComponent };